import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@emotion/react';
import { getStyleProps } from '../utils';
export const placeholderCSS = ({
  theme: {
    spacing,
    colors
  }
}, unstyled) => ({
  label: 'placeholder',
  gridArea: '1 / 1 / 2 / 3',
  ...(unstyled ? {} : {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  })
});
const Placeholder = props => {
  const {
    children,
    innerProps
  } = props;
  return jsx("div", _extends({}, getStyleProps(props, 'placeholder', {
    placeholder: true
  }), innerProps), children);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Placeholder;